import { format } from "date-fns";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useDeleteTpnMutation, useTpnByDateQuery } from "../../services/tpnApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import TpnView from "../Common/Modal/TpnView";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import Swal from "sweetalert2";

const Tpn = () => {
  const navigate = useNavigate();
  let i = 1;
  const [aamarId, setAamarId] = useState("");
  const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [tpnView, setTpnView] = useState("");
  const lang = useSelector((state) => state.languageReducer);

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  const [totalTpn, setTotalTpn] = useState(0);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [warehouse, setWarehouse] = useState("allWh");

  const { data, isSuccess, isLoading, isFetching, refetch } = useTpnByDateQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
  });
  // console.log("data", data);
  const [deleteTpn] = useDeleteTpnMutation();

  const auth = signInUser();

  useEffect(() => {
    refetch();
  }, [startDate, endDate, warehouse, aamarId]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);
  useEffect(() => {
    setAamarId(auth?.aamarId);
  }, []);

  useEffect(() => {
    let total = 0;
    if (data?.length > 0) {
      data.forEach((tpn) => {
        if (tpn.status !== "Canceled") {
          total = total + parseFloat(tpn.total);
        }
      });
      setTotalTpn(total);
    }
  }, [data]);

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);

  const navigateToCreateTPN = () => {
    navigate(`/tpn-out`);
  };
  const navigateToReceiveTpn = () => {
    navigate(`/tpn-received`);
  };
  const deleteHandler = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you Sure?",
        text: "Delete this tpn?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        setLoader(true);
        const res = await deleteTpn(id);
        if (res) {
          // TODO::
          notify("Tpn Deleted Successful!", "success");
          // add error hendaler for delete error
          // console.log(res);
        } else {
          // console.log("Delete Operation Canceled by Tpn!");
          return;
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };
  const tpnDetailsHandler = (id) => {
    setTpnView(id);
    setShow(true);
  };
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };
  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.TPN}></Header>
            <div className="row">
              <div className="col-md-7">
                {/* Sort date range */}
                <div className="date-picker d-md-flex mt-2 mb-2 align-items-center gap-2">
                  <div className="date-picker d-flex mt-2 mb-2 align-items-center gap-2">
                    {/* <b>Start:</b> */}
                    <DatePicker
                      selected={new Date(startDate)}
                      className="form-control me-2"
                      onChange={(date) =>
                        setStartDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                    <span width="10px"></span>
                    {/* <b>End:</b> */}
                    <DatePicker
                      selected={new Date(endDate)}
                      className="form-control"
                      onChange={(date) =>
                        setEndDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                  </div>
                  <div>
                    {auth?.type === "admin" && (
                      <div
                        className="mt-2 mt-md-0 mb-2 mb-md-0 "
                        style={{
                          width:
                            window.innerWidth >= 1024
                              ? 280
                              : window.innerWidth >= 768
                              ? 280
                              : "100%", // Adjust width based on screen size
                        }}
                      >
                        <WareHouseDW
                          id="warehouse"
                          name="warehouse"
                          handleOnChange={handleOnchangeWareHouseFrom}
                          className="form-control "
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <Button
                  className="btn btn-dark mb-2 float-end mt-2 me-2"
                  onClick={() => navigateToCreateTPN()}
                >
                  <Icons.Plus />
                  {" "}{lang?.createTpn || "Create TPN"}
                </Button>
                <Link
                  className="btn btn-dark mb-2 float-end mt-2 me-2"
                  to="/tpn-details"
                >
                  <Icons.ChartBar /> {lang?.report || "Report"}
                </Link>
              </div>
              <div className="col-md-12">
                <div className="mt-3 table-responsive">
                  <table className="table table-striped ">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">TPN ID</th>
                        <th scope="col">TPN Date</th>
                        <th scope="col">Warehouse From</th>
                        <th scope="col">Warehouse To</th>
                        <th scope="col">Prepared By</th>
                        <th scope="col">Total items</th>
                        <th scope="col">Total </th>
                        <th scope="col">Note</th>
                        <th scope="col">Status</th>
                        <th scope="col">ActionBtn</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {console.log(data)} */}
                      {data?.length > 0 ? (
                        data?.map((tpn) => (
                          <tr key={tpn._id}>
                            <th scope="row">{i++}</th>
                            <td>{tpn?.tpnNo}</td>
                            <td>
                              {tpn?.createdAt &&
                                format(new Date(tpn.createdAt), "MM/dd/yyyy")}
                            </td>
                            <td>{tpn?.warehouseFrom?.name}</td>
                            <td>{tpn?.warehouseTo?.name}</td>
                            <td>{tpn?.userId?.name}</td>
                            <td>{tpn?.products?.length}</td>
                            <td>
                              {new Intl.NumberFormat().format(
                                parseFloat(tpn.total).toFixed(2)
                              )}
                            </td>
                            <td>{tpn.note}</td>
                            <td>{tpn.status}</td>
                            <td>
                              <Icons.EyeOutline
                                className="icon-eye"
                                onClick={() => tpnDetailsHandler(tpn._id)}
                                size={20}
                              ></Icons.EyeOutline>
                              {tpn.status !== "Canceled" &&
                                auth?.type === "admin" && (
                                  <Icons.TrashOutline
                                    className="icon-trash"
                                    onClick={() => deleteHandler(tpn._id)}
                                    size={20}
                                  />
                                )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr colSpan={9}>No tpn Found</tr>
                      )}
                      {
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <b>Grand Total</b>
                          </td>
                          <td>
                            <b>
                              {new Intl.NumberFormat().format(
                                parseFloat(totalTpn).toFixed(2)
                              )}
                            </b>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TpnView show={show} handleClose={handleClose} tpn={tpnView}></TpnView>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default Tpn;
